<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">

  <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;width:92%">

    <span  style="font-size: 25px;">{{'Policies and Procedures' | translate | async}}</span>
    <span class="material-icons" style="margin-left: 90%; font-size: 27px; cursor: pointer;" (click)="NavigateToCreatePolicyProcedureComponent()">articlearrow_right_althome</span>
    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height: auto;">

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'State' | translate | async}}" [formControl]="buildStateFormControl"  [(ngModel)]="SelectedState" multiple required>
          <mat-option (click)="selectAllState(ev)"    [value]="0"
          #ev
           >{{'Select All' | translate | async}}</mat-option>
          <mat-option [value]="state.Id" *ngFor="let state of StateList" (click)="stateChange(state.Id)" >{{state.SiteName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Department' | translate | async}}" [formControl]="buildDepartmentFormControl"  [(ngModel)]="SelectedDepartment" multiple>
          <mat-option (click)="selectAllDepartment(ev)"    [value]="0"
          #ev
           >{{'Select All' | translate | async}}</mat-option>
          <mat-option [value]="dept.ID" *ngFor="let dept of filteredwDepartmentlist" (click)="departmentChange(dept.ID)" >{{dept.DepartmentName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Work Area' | translate | async}}" [formControl]="buildnoFormControl"  [(ngModel)]="SelectedWorkArea" multiple>
          <mat-option (click)="selectAllWorkArea(ev)"    [value]="0"
          #ev
           >{{'Select All' | translate | async}}</mat-option>
          <mat-option [value]="model.ID" *ngFor="let model of filteredWorkList" (click)="workAreaChange(model.ID)" >{{model.WorkAreaName}}</mat-option>
        </mat-select>
      </mat-form-field>
    
      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate">
        <mat-placeholder>{{'Issue Start Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate">
        <mat-placeholder>{{'Issue End Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>
   
    </div>
    <div style="display: flex;flex-direction: row;">
      <button (click)="RestFields()"  class="button button--primary"><span class="button__text"
         >{{'Reset' | translate | async}}</span></button>
      <button (click)="searchPolicyProcedureDetails()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
          >{{'Search' | translate | async}}</span></button>
    </div>
  </mat-card>


  <div style="width: 100%;">
    <div style="display: flex;min-width: 30%;height:40px; margin-top: 1%;">
      <span style="cursor: pointer;font-size: 17px;margin-left: 2%;"></span>

    </div>
    <div class="spinner" *ngIf="loading">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  <div *ngIf="SearchResultsList.length>0 && !loading" >   
 
   <table id="table_detail" cellpadding=10 class="table table--full-width table--striped" style="margin-left: 2%;">

    <tr>
        <th>{{'State' | translate | async}} </th>
        <th>{{"Department" | translate | async}}</th>
        <th style="padding: 0px 24px;">{{'Work Area' | translate | async}} </th>
        <th style="padding: 0px 24px;">{{'Document Heading' | translate | async}} </th>
        <th style="padding: 0px 24px;">{{'Date Issued' | translate | async}}</th>
        <th style="padding: 0px 24px;">{{'Expiry Date' | translate | async}}</th>
        <th></th>

    </tr>
    <ng-container  *ngFor="let sr of SearchResultsList">
        <tr style="cursor: pointer;">

            <td (click)=" onClickOpenForm(sr.PolicyID)" style="cursor: pointer;">{{sr.SiteNames}}</td>
            <td (click)=" onClickOpenForm(sr.PolicyID)" style="cursor: pointer;"> {{sr.DepartmentNames}}</td>
            <td (click)=" onClickOpenForm(sr.PolicyID)" style="cursor: pointer;">{{sr.WorkAreaNames}}</td>
            <td (click)=" onClickOpenForm(sr.PolicyID)" style="cursor: pointer;">{{sr.PolicyName}}</td>
            <td (click)=" onClickOpenForm(sr.PolicyID)" style="cursor: pointer;">{{sr.IssuedDate | date:'dd MMM yyyy'}}</td>
            <td (click)=" onClickOpenForm(sr.PolicyID)" style="cursor: pointer;">{{sr.ExpiredDate | date:'dd MMM yyyy'}}</td> 
            <td>
              <i style="cursor: pointer;" *ngIf="sr.IsExpand" class="material-icons ttmodal__close-button"
              (click)="ChangeExpand(sr)" matTooltip="Show Less">expand_less</i>
              <i style="cursor: pointer;" *ngIf="!sr.IsExpand" class="material-icons ttmodal__close-button"
              (click)="ChangeExpand(sr)" matTooltip="Show More">expand_more</i>
          </td>
        </tr>
        <tr>
          <td colspan=9>
              <table class="table table--full-width table--striped" *ngIf="sr.IsExpand"
                  style="margin-left: 2%; border: groove;">
                  <thead>
                      <tr>
                          <th  style="padding: 0px 24px;width: 10%;">{{'User' | translate | async}} </th>
                          <th style="padding: 0px 24px;width: 10%;">{{"Action" | translate | async}}</th>
                          <th style="padding: 0px 24px;width: 10%;">{{'Field Changed' | translate | async}} </th>            
                          <th style="padding: 16px 24px;width: 10%;;"> {{'Date' | translate | async}}</th>
                          <th style="padding: 16px 24px;width: 10%;;"> {{'From' | translate | async}}</th>
                          <th style="padding: 16px 24px;width: 10%;;">{{'To' | translate | async}} </th>
                          
                      </tr>
                  </thead>
                  <tbody>
                      <ng-container  *ngFor="let im of sr.policyProcedureAuditTrailsVM">
                          <tr> 
                              <td >{{im.ModifiedUserName}}</td>
                              <td> {{im.Action}}</td>
                              <td>{{im.FieldName}}</td>
                              <td> {{im.ModifiedDate}}</td>
                              <td> {{im.OldValue}}</td>
                              <td>  {{im.NewValue}}</td>                               
                          </tr>

                      </ng-container>
                  </tbody>

              </table>
          </td>

      </tr>
    </ng-container>

</table>
  </div>
    <div style="display: flex;flex-direction: column;align-items: center;
     justify-content: center;min-height: 500px;align-self: center;">
    </div>
  </div>
</div>